/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A balanced GGCC window has a skew of 0.`)
};

const es_gcskew_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una ventana GGCC equilibrada tiene un sesgo de 0.`)
};

const de_gcskew_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein ausgewogenes GGCC-Fenster hat einen Skew von 0.`)
};

const nl_gcskew_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een evenwichtig GGCC-venster heeft een skew van 0.`)
};

const fr_gcskew_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une fenêtre équilibrée GGCC a un biais de 0.`)
};

const it_gcskew_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una finestra GGCC bilanciata ha uno skew di 0.`)
};

const pt_br2_gcskew_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma janela GGCC balanceada tem skew de 0.`)
};

const pt_gcskew_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma janela GGCC equilibrada tem uma assimetria de 0.`)
};

const ja_gcskew_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バランスの取れたGGCC窓のスキューは0です。`)
};

const zh_gcskew_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`均衡的 GGCC 窗口偏斜为 0。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_ex3", locale)
	if (locale === "en") return en_gcskew_ex3(inputs)
	if (locale === "es") return es_gcskew_ex3(inputs)
	if (locale === "de") return de_gcskew_ex3(inputs)
	if (locale === "nl") return nl_gcskew_ex3(inputs)
	if (locale === "fr") return fr_gcskew_ex3(inputs)
	if (locale === "it") return it_gcskew_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_ex3(inputs)
	if (locale === "pt") return pt_gcskew_ex3(inputs)
	if (locale === "ja") return ja_gcskew_ex3(inputs)
	return zh_gcskew_ex3(inputs)
};